module.exports = __webpack_public_path__ + "static/media/folder.3dfe14d6.svg";